/* Senfineco app gate - one small sheet at the bottom of the screen:
   - inside the app: "a new version is available" when the installed version is
     older than the one on the stores (bot.senfineco.shop/app-version);
   - in a phone browser: a quiet "get the app" bar after a while of browsing.
   bot.senfineco.shop/app-update sends each phone to its own store. */
(() => {
  'use strict';
  if (window.SenfAppGate) return;
  window.SenfAppGate = true;
  const UA = navigator.userAgent || '';
  const IN_APP = UA.indexOf('SenfinecoApp') >= 0;
  const AR = !String(document.documentElement.lang || 'ar').toLowerCase().startsWith('en');
  const PHONE = /iPhone|iPod|Android.*Mobile|Windows Phone/i.test(UA) || (matchMedia('(max-width: 820px)').matches && 'ontouchstart' in window);
  const LINK = 'https://bot.senfineco.shop/app-update';
  const VER = 'https://bot.senfineco.shop/app-version';
  const SNOOZE = 'senfAppGateV1';
  const t = (a, e) => (AR ? a : e);
  if (/\/(cart|checkout|challenge|account\/login|tools)/.test(location.pathname)) return;

  const snoozedUntil = () => { try { return Number(localStorage.getItem(SNOOZE) || 0); } catch (_) { return 0; } };
  const snooze = (days) => { try { localStorage.setItem(SNOOZE, String(Date.now() + days * 864e5)); } catch (_) {} };

  function style() {
    if (document.getElementById('senf-app-gate-css')) return;
    const css = document.createElement('style');
    css.id = 'senf-app-gate-css';
    css.textContent = [
      '.senf-gate{position:fixed;inset-inline:0;bottom:0;z-index:2147483000;display:flex;justify-content:center;padding:10px 12px calc(10px + env(safe-area-inset-bottom,0px));pointer-events:none}',
      '.senf-gate__card{pointer-events:auto;width:min(520px,100%);display:flex;align-items:center;gap:12px;background:#fff;color:#1F2933;border:1px solid #E6E9EF;border-radius:16px;padding:12px 14px;box-shadow:0 10px 30px rgba(2,52,58,.16);transform:translateY(130%);transition:transform .28s ease}',
      '.senf-gate.is-in .senf-gate__card{transform:none}',
      '.senf-gate__ico{flex:none;width:44px;height:44px;border-radius:12px;object-fit:cover;background:#02343A}',
      '.senf-gate__txt{flex:1;min-width:0;line-height:1.35}',
      '.senf-gate__txt b{display:block;font-size:14px;font-weight:700}',
      '.senf-gate__txt span{display:block;font-size:12px;color:#8A94A6;margin-top:2px}',
      '.senf-gate__go{flex:none;background:#F06A1F;color:#fff;border:0;border-radius:10px;font:inherit;font-size:13px;font-weight:700;padding:9px 14px;cursor:pointer;text-decoration:none}',
      '.senf-gate__x{flex:none;background:transparent;border:0;color:#8A94A6;font-size:20px;line-height:1;padding:4px 6px;cursor:pointer}'
    ].join('');
    document.head.appendChild(css);
  }

  // Sit above the store's own bottom tab bar, and keep clear of the floating
  // WhatsApp button, instead of covering either of them.
  function fit(wrap) {
    const dock = document.querySelector('.sf26-dock, .sf26-app-dock');
    if (dock) {
      const box = dock.getBoundingClientRect();
      if (box.height && getComputedStyle(dock).display !== 'none') wrap.style.bottom = Math.round(box.height) + 6 + 'px';
    }
    const base = parseInt(wrap.style.bottom || '0', 10) || 0;
    const band = innerHeight - base - 110;
    document.querySelectorAll('[class*="whatsapp"], [id*="whatsapp"]').forEach((el) => {
      if (getComputedStyle(el).position !== 'fixed') return;
      const r = el.getBoundingClientRect();
      if (!r.width || r.width > 120 || r.bottom < band) return;
      const side = r.left + r.width / 2 < innerWidth / 2 ? 'paddingLeft' : 'paddingRight';
      wrap.style[side] = Math.round(r.width) + 22 + 'px';
    });
  }

  function sheet(o) {
    style();
    const wrap = document.createElement('div');
    wrap.className = 'senf-gate';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-label', o.title);
    const icon = window.SENF_APP_ICON
      ? '<img class="senf-gate__ico" src="' + window.SENF_APP_ICON + '" alt="" width="44" height="44">'
      : '<span class="senf-gate__ico"></span>';
    wrap.innerHTML = '<div class="senf-gate__card">' + icon +
      '<div class="senf-gate__txt"><b></b><span></span></div>' +
      '<a class="senf-gate__go" href="' + LINK + '" rel="noopener"></a>' +
      '<button class="senf-gate__x" type="button" aria-label="' + t('اغلاق', 'Close') + '">&times;</button></div>';
    wrap.querySelector('b').textContent = o.title;
    wrap.querySelector('span').textContent = o.note;
    wrap.querySelector('.senf-gate__go').textContent = o.cta;
    wrap.querySelector('.senf-gate__x').addEventListener('click', () => {
      wrap.classList.remove('is-in');
      setTimeout(() => wrap.remove(), 300);
      if (o.onClose) o.onClose();
    });
    document.body.appendChild(wrap);
    fit(wrap);
    requestAnimationFrame(() => wrap.classList.add('is-in'));
  }

  function newer(remote, local) {
    const p = (v) => String(v || '').trim().split('.').map((n) => parseInt(n, 10) || 0);
    const a = p(remote), b = p(local);
    for (let i = 0; i < Math.max(a.length, b.length); i++) { const x = a[i] || 0, y = b[i] || 0; if (x !== y) return x > y; }
    return false;
  }

  function askUpdate() {
    const m = UA.match(/SenfVer\/([0-9.]+)/);
    const current = m ? m[1] : '0';
    const ios = /iPhone|iPad|iPod|\(iOS\)/i.test(UA);
    fetch(VER, { mode: 'cors' }).then((r) => r.json()).then((d) => {
      const info = d && d[ios ? 'ios' : 'android'];
      if (!info || !newer(info.version, current)) return;
      sheet({
        title: t('يوجد تحديث جديد للتطبيق', 'A new app version is available'),
        note: t('حدّث التطبيق للحصول على آخر التحسينات.', 'Update to get the latest improvements.'),
        cta: t('تحديث', 'Update'),
        onClose: () => snooze(3)
      });
    }).catch(() => {});
  }

  function askInstall() {
    sheet({
      title: t('تطبيق سنفينكو', 'The Senfineco app'),
      note: t('تسوّق أسرع وتابع طلباتك من جوالك.', 'Shop faster and follow your orders from your phone.'),
      cta: t('تحميل', 'Get'),
      onClose: () => snooze(14)
    });
    snooze(7);
  }

  function start() {
    if (Date.now() < snoozedUntil()) return;
    if (IN_APP) { setTimeout(askUpdate, 4000); return; }
    if (!PHONE) return;
    setTimeout(askInstall, 12000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();